/* eslint-disable react/display-name */
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Card,
  message,
  Menu,
  Dropdown,
  Button,
  Switch,
} from "antd";
import SweetAlert from "react-bootstrap-sweetalert";
import Auxiliary from "util/Auxiliary";
import { useDispatch, useSelector } from "react-redux";
import {
  getTeacherDetails,
  updateDashboardFilter,
  getClassLeaderboard,
} from "../../appRedux/actions/Dashboard";
import {
  GRADES,
  SECTIONS,
} from "../../constants/AppConstants";

import FormItem from "antd/lib/form/FormItem";
import CircularProgress from "components/CircularProgress";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import DummyContentAlert from "../../util/DummyContentAlert";
import {
  NotificationContainer,
} from "react-notifications";
import FlipMove from 'react-flip-move';
import LeaderboardCard from "../../components/Leaderboard/LeaderboardCard";
import { sortBy, partition } from "lodash";
import invitestudents from 'assets/images/dashboard/invitestudents.gif'
const Leaderboard = () => {
  const dispatch = useDispatch();
  const {
    teacher_details,
    dashboard_filters = {},
    loader,
    showMessage,
    alertMessage,
    leaderboard = [],
    loading_leaderboard = false
  } = useSelector(({ dashboard }) => dashboard);
  const [level, setLevel] = useState(dashboard_filters.level || 10);
  const [section, setSection] = useState(dashboard_filters.section || "A");
  const [subject] = useState(
    dashboard_filters.subject || "physics"
  );
  const [showSubscribeAlert, setShowSubscribeAlert] = useState(false);
  const [board, setBoard] = useState(
    dashboard_filters ? dashboard_filters.board : "CBSE"
  );
  
  
  const customEnterAnimation = {
    from: {transform: 'scale(0.5, 1)'},
    to: {transform: 'scale(1, 1)'}
  };
  
  useEffect(() => {
    if(!teacher_details){
      dispatch(getTeacherDetails());
    }
  }, []);
  useEffect(() => {
    if (teacher_details) {
      dispatch(getClassLeaderboard());
    }
    else{
      dispatch(getTeacherDetails());
    }
  }, [teacher_details]);
  useEffect(() => {
    updateFilters();
  }, [level, subject, board,section]);
  const updateFilters = () => {
    const payload = {
      board: board,
      level: level,
      subject: subject,
      section: section
    };
    dispatch(updateDashboardFilter(payload));
    setTimeout(() => {
      dispatch(getClassLeaderboard());
    }, 1000);
  };
  const getLeaderboardColumnSplit = ()=>{
    // let leaderboarddata = JSON.parse("[{\"board\":\"CBSE\",\"rank_change\":-29,\"name\":\"Sara Sen\",\"lastseen_at\":\"1595483891576\",\"user_avatar\":\"https://quiznextpublic.s3.ap-south-1.amazonaws.com/assets/Avatars/propack/girl-10.png\",\"section\":\"A\",\"level\":9,\"monthly_points\":25064,\"monthly_rank\":344,\"skill_level\":5,\"id\":\"63461d00-aa42-459d-a5d3-4e8681cd2b5c\",\"isSubscribed\":true,\"badge_level\":3,\"is_online\":false,\"avatar\":\"https://quiznextpublic.s3.ap-south-1.amazonaws.com/assets/Avatars/propack/girl-10.png\"},{\"user_avatar\":\"avatar03\",\"level\":9,\"board\":\"CBSE\",\"monthly_points\":1377,\"monthly_rank\":1854,\"rank_change\":512,\"id\":\"2d37b7b2-da32-4917-a3c8-52f70d6832c7\",\"name\":\"Gurunew\",\"lastseen_at\":\"1595482415961\",\"is_online\":false,\"avatar\":\"https://quiznextpublic.s3.ap-south-1.amazonaws.com/assets/Avatars/app_avatars/avatar03.png\"}]");
    let leaderboarddata = [...leaderboard];
    leaderboarddata = sortBy(leaderboarddata,(s)=>s.monthly_points).reverse()
    leaderboarddata = leaderboarddata.map((s,rankIndex)=>{return {...s,rankIndex:rankIndex+1}})
    // if (test.length <= 20){
    //   split =  chunk(test,10)
    // }
    const groupLength = leaderboarddata.length
    const  split =  partition(leaderboarddata,s=>s.rankIndex <= Math.floor(groupLength/2))

    return split
  }
  return (
    <Auxiliary>
      <SweetAlert
        show={showSubscribeAlert}
        warning
        showCancel
        confirmBtnText="Ok"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        title={
          "Your account is not verified yet.\n You cannot assign quizzes to your class till we verify that you are an authorized person and working at this school. Contact support@quiznext.in for assistance."
        }
        onConfirm={() => {
          setShowSubscribeAlert(false);
        }}
        onCancel={() => {
          setShowSubscribeAlert(false);
        }}
      ></SweetAlert>
      <Card 
          style={{...styles.filter_card_container}} 
          bodyStyle={{...styles.filter_card_body}}>
        <Switch
          style={{ position: "absolute", right: 5, top: 5 }}
          checkedChildren="CBSE"
          unCheckedChildren="ICSE"
          defaultChecked
          onChange={(v) => setBoard(v ? "CBSE" : "ICSE")}
          checked={board === "CBSE"}
          className="gx-qn-switch"
          size={"small"}
        />
        <Row title="Select class and subject" style={{paddingLeft:"10px",paddingTop:"25px",margin:"0px"}}>
          <Col xl={4} lg={4} md={6} sm={10} xs={10}>
            <FormItem
              label="Grades"
              className="gx-form-item-one-fourth"
              labelAlign="left"
              labelCol={0}
            >
              <Dropdown
                overlay={
                  <Menu
                    value={level}
                    onClick={(e) => {
                      setLevel(parseInt(e.key));
                    }}
                  >
                    {GRADES.map((grade) => (
                      <Menu.Item key={grade}>{grade}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <Button>
                  {level} <DownOutlined />
                </Button>
              </Dropdown>
            </FormItem>
          </Col>
          <Col xl={4} lg={4} md={6} sm={10} xs={10}>
            <FormItem
              label="Section"
              className="gx-form-item-one-fourth"
              labelAlign="left"
              labelCol={0}
            >
              <Dropdown
                overlay={
                  <Menu
                    value={level}
                    onClick={(e) => {
                      // console.log(e);
                      setSection(e.key);
                    }}
                  >
                    {SECTIONS.map((section) => (
                      <Menu.Item key={section}>{section}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <Button>
                  {section} <DownOutlined />
                </Button>
              </Dropdown>
            </FormItem>
          </Col>
          <Col xl={1} lg={1} md={1} sm={1} xs={1} style={{paddingTop:"10px"}}>
              {loading_leaderboard && <LoadingOutlined style={{fontSize:"20px", fontWeight:"bold", color:"secondary"}}/>}
          </Col>
        </Row>
      </Card>
      <Row>
        <Col span={24}>
          <div className="gx-card">
            <div className="gx-card-body">
              <Row>
                <DummyContentAlert
                  subscribed={
                    teacher_details ? teacher_details.subscribed : false
                  }
                />
              </Row>
                {(leaderboard && leaderboard.length)?<FlipMove
                  staggerDurationBy="30"
                  duration={500}
                  enterAnimation={customEnterAnimation}>
                  {
                    getLeaderboardColumnSplit().map((group,index) => {
                      return <Row key={`leaderboard_row_group_${index}`}>
                        {
                          group.map((student) => (
                            // <Row  >
                              <Col key={student.id} xl={11} xxl={11} lg={11} md={11} sm={24} xs={24}>
                                <LeaderboardCard details={student} />
                            </Col>
                            ))
                        }
                      </Row>
                    })
                  }
                </FlipMove>:(<span><h2>No students found. Invite students to see the leaderboard. </h2><img src={invitestudents}></img></span>)}
            </div>
          </div>
        </Col>
      </Row>
      {/* <div className="gx-loader-view">
        <CircularProgress />
      </div> */}
      {loader ? (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      ) : null}
      {showMessage ? message.error(alertMessage.toString()) : null}
      <NotificationContainer />
    </Auxiliary>
  );
};

const styles = {
  filter_card_container:{padding:"0px"},
  filter_card_body:{
    padding:"0px", margin:"0px"
  }
}
export default Leaderboard;
